import GetCompanyByExternalIdAsyncRequestModelBase from '../_generated/modelBases/get-company-by-external-id-async-request-model-base';

export default class GetCompanyByExternalIdAsyncRequestModel extends GetCompanyByExternalIdAsyncRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
